<template>
    <content menu="团队介绍" :location ="location"> 
        <view class="data-content">
            <view class="name">{{name}}</view>
            <view class="img">
                <img  :src=imgPath />
            </view>
            <view class="text">
                <p v-for="(item, index) in texts" :key="index">{{item}}</p>
            </view>
        </view>
    </content>

  
</template>


<script>
    import content from '../content.vue'
    const cityData = require('../../../assets/data.json')
	export default {
		name:"ApplicationForm",
        components:{
            content,
        },
		props:{
		},
		data() {
			return {
                name:'',
				imgPath:'',
				texts:[],
                location:[]
			};
		},
		methods:{
		},
        created(){
            console.log(this.$route.query.id);

            let id = this.$route.query.id;
			let json = cityData[id];

			this.name = json['name'];
			this.imgPath = json['imgPath'];
			this.texts = json['texts'];

            this.location =[];
            this.location.push("团队介绍");
            this.location.push(	this.name);
        }
	}
</script>

<style lang="scss" scoped>

    .data-content{
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .name{
            margin: 10px 0;
            font-size: 2.8ch;
        }
        .img{
            width: 400px;
            margin: 20px 0;
            img{
                height: 100%;
                width: 100%;
            }
        }
        .text{
            margin: 10px 20px;
            margin-bottom: 40px;
            p{
                text-indent:30px;
                line-height: 3.2ch;
                margin-top: 24px;
            }
        }
    }
</style>
